/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import * as moment from 'moment/moment';
import {finalize} from 'rxjs/operators';

import {Employee, SelectEmployee} from '../../../+employees/emp-tree/emp-tree.interfaces';
import {EmpTreeService} from '../../../+employees/emp-tree/emp-tree.service';
import {DATE_FORMAT} from '../../../app.constants';

import {AbstractField} from './abstract-field';

/**
 * An tree widget to select a value from a tree
 */
@Component({
  selector: 'gp-form-field-people-tree',
  template: `
    <ng-select class="form-control"
               [(ngModel)]="value.value"
               [formControl]="control"
               [attr.test-id]="descriptor.zoneID"
               [idField]="'id'"
               [textField]="'select'"
               [items]="data"
               [readOnly]="readOnly"
               [active]="activeValue"
               (selected)="select($event)"
               style="height: 37px">
    </ng-select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActiveEmployeeFieldComponent extends AbstractField implements OnInit {
  public today: string = moment().format(DATE_FORMAT);
  public data: SelectEmployee[];
  public activeValue: number;

  constructor(private changeDetectorRef: ChangeDetectorRef,
              private empTreeService: EmpTreeService) {
    super();
  }

  public ngOnInit(): void {
    this.empTreeService.getEmployees(this.today, this.today)
      .pipe(
        finalize(() => {
          this.activeValue = this.value.value;
          this.changeDetectorRef.markForCheck();
        })
      )
      .subscribe((response) => {
        this.data = this.empTreeService
          .generateSelectEmployeeList(response, -1);
        if (!this.descriptor.metadatas) {
          this.descriptor.metadatas = {};
        }
        this.descriptor.metadatas.items = response;
      });
  }

  public select(item: { id: number, text: string }): void {
    const employee: Employee = this.findItem(item.id);
    this.value.transId = employee.name;
  }

  public findItem(id: number): Employee {
    return this.descriptor.metadatas.items
      .find(element => element.id === id);
  }
}
